module.exports = __webpack_public_path__ + "static/media/apps-screen.8fd31096.webp";